<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { utils } from 'frontend-js-shared'

export default {
  computed: {
    ...mapGetters(['account', 'organization']),

    isOrganizationAdmin() {
      return Boolean(this.account?.isAdmin || this.account?.isOrganizationAdmin)
    },

    targetCurrency() {
      if (this.isOrganizationAdmin) {
        return this.organization?.currency ?? ''
      }

      return this.account?.site?.currency || this.organization?.currency || ''
    },
  },

  methods: {
    formatToUserCurrency(value) {
      if (!_.isNumber(value)) return '—'

      return this.formatMoney(value, this.targetCurrency)
    },

    formatToOrganizationCurrency(value) {
      if (!_.isNumber(value)) return '—'

      return this.formatMoney(value, this.organization?.currency ?? '')
    },

    formatMoney(value, targetCurrency) {
      const { amount, currency } = utils.money.convertCurrency({
        amount: value,
        inputCurrency: 'USD',
        targetCurrency,
        allowedSiteCurrencies: this.organization?.allowedSiteCurrencies ?? [],
        organizationCurrency: this.organization?.currency ?? '',
      })

      return utils.money.formatCurrency({
        amount,
        currency,
        locale:
          globalThis.navigator?.language ||
          globalThis.navigator?.userLanguage ||
          'en',
      })
    },
  },
}
</script>
